import { z } from "zod";
import { AgencyIdSchema } from "../primitives/ids.js";
/**
 * PF-002 — North Star agency role set.
 * CLIENT / AI / SYSTEM are modeled for fail-closed checks but are not inviteable
 * agency-human roles (no tenant-bypass client privilege).
 */
export const AgencyRoleSchema = z.enum([
    "OWNER",
    "ADMIN",
    "OPERATOR",
    "DESIGNER",
    "ACCOUNT_MANAGER",
    "MEMBER",
    "CLIENT",
    "AI",
    "SYSTEM",
]);
/** Roles that may be assigned to agency human users via invite/create paths. */
export const AgencyAssignableRoleSchema = z.enum([
    "OWNER",
    "ADMIN",
    "OPERATOR",
    "DESIGNER",
    "ACCOUNT_MANAGER",
    "MEMBER",
]);
export const AgencyAuthLoginRequestV1Schema = z
    .object({
    email: z.string().email().max(320),
})
    .strict();
export const AgencyAuthLoginRequestResultV1Schema = z
    .object({
    ok: z.literal(true),
    /** Dev/staging only — omitted in production responses. */
    magicLinkVerifyPath: z.string().min(1).optional(),
})
    .strict();
export const AgencyAuthLoginVerifyV1Schema = z
    .object({
    token: z.string().min(16).max(2048),
})
    .strict();
export const AgencyAuthSessionV1Schema = z
    .object({
    agencyId: AgencyIdSchema,
    agencyUserId: z.string().min(1),
    email: z.string().email(),
    name: z.string().nullable().optional(),
    role: AgencyRoleSchema,
    expiresAt: z.string().datetime(),
    /** PF-003 additive — present on hardened session responses. */
    sessionId: z.string().min(1).optional(),
    /** PF-003 additive — opaque device binding when set at login/rotate. */
    deviceLabel: z.string().max(128).nullable().optional(),
})
    .strict();
/** PF-003 — empty-body rotate request (cookie session required). */
export const AgencyAuthSessionRotateV1Schema = z.object({}).strict();
export const AgencyInviteCreateV1Schema = z
    .object({
    email: z.string().email().max(320),
    role: AgencyAssignableRoleSchema.default("MEMBER"),
})
    .strict();
export const AgencyInviteCreateResultV1Schema = z
    .object({
    inviteId: z.string().min(1),
    email: z.string().email(),
    role: AgencyAssignableRoleSchema,
    expiresAt: z.string().datetime(),
    /** Dev/staging only — omitted in production responses. */
    inviteAcceptPath: z.string().min(1).optional(),
})
    .strict();
export const AgencyInviteAcceptV1Schema = z
    .object({
    token: z.string().min(16).max(2048),
    name: z.string().min(1).max(200).optional(),
})
    .strict();
//# sourceMappingURL=agency-auth.js.map